import React from 'react';
import { Descriptions } from 'antd';

export default function CompanyDeregistrationApplicationView({ formData = {} }) {
  return (
    <Descriptions column={1} size="small" bordered>
      <Descriptions.Item label="注销公司">{formData.company_name || '-'}</Descriptions.Item>
      <Descriptions.Item label="注销原因">{formData.dereg_reason || '-'}</Descriptions.Item>
    </Descriptions>
  );
}
